import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { enGB, es, pt } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import CustomSelectArray from "./CustomSelectArray";
import SwitchOnAndOff from "./SwitchOnAndOff";
import axios from "axios";
import Loader from "./Loader";
import { api } from "../App";
import { fetchOpenClosedExceptions, createOpenClosedExceptions, fetchPlaceOfTable } from "../actions/restaurantActions";
import styled from "styled-components";
import DropDownButton from "./DropDownButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCalendar, faMapLocation, faCircleXmark, faClock, faUser, faSun } from "@fortawesome/free-solid-svg-icons";
import { XSvgIcon } from "../icons/SvgIcons";
import { ContainerBox, Header, Body, OrangeButton, Title, Container } from "./DefaultImports";
import TimeInputLessPlus from "./TimeInputLessPlus";
import DropDownButtonTime from "./DropDownButtonTime";
const StyledDateRangePicker = styled(DateRangePicker)`
  width: auto;
  margin: 0 auto;
  border-radius: 10px;
  .rdrDefinedRangesWrapper {
    display: none;
  }
`;
const HorizontalItemBox = styled.div`
  background-color: #ffffff;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 10px;
  position: relative;
`;
const ActionButton = styled.button`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #ee754c;
  font-size: 20px;
  cursor: pointer;

  &:hover {
    color: #4b3335;
  }
`;
const SubmitButton = styled(OrangeButton)`
  background-color: #9fbbc1;
  border: none;

  &:hover {
    background-color: #4b3335;
  }
`;
const FormGroup = styled.div`
  margin-bottom: 1rem;
`;
const InsideFormGroup = styled.div`
  width: 100%;
  display: flex;
  flex: wrap;
`;
const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;

  width: 60px; /* Initial size */
  min-width: 60px; /* Minimum size */
  max-width: max-content; /* Automatically expands to fit the content */
`;
const generateIntervalOptions = () => {
  const intervalOptions = [];
  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 60; j += 15) {
      // Format the hour and minute values to have two digits
      const hour = i.toString().padStart(2, "0");
      const minute = j.toString().padStart(2, "0");
      const time = `${hour}:${minute}`;
      if (time >= "00:00" && time <= "24:00") {
        intervalOptions.push(time);
      }
    }
  }
  return intervalOptions;
};
const OpenClosedExceptions = ({
  restaurant_id
}) => {
  const { t, i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const dateLocale = language === "pt" ? pt : language === "es" ? es : enGB;
  const dispatch = useDispatch();
  const params = useParams();
  useEffect(() => {
    if (restaurant_id) {
      dispatch(fetchOpenClosedExceptions(restaurant_id));
      dispatch(fetchPlaceOfTable(restaurant_id));
    }
  }, [dispatch, restaurant_id]);
  const restaurantZones = useSelector(state => state.restaurantZones);
  const {
    zones = []
  } = restaurantZones;
  const openClosedExceptions = useSelector(state => state.openClosedExceptions);
  const {
    exceptions
  } = openClosedExceptions;
  const [showModal, setShowModal] = useState(false);
  const [zone_list, setZone_list] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [numberOfAcceptance, setNumberOfAcceptance] = useState(0);
  const [showExceptionDaysDeleteModal, setShowExceptionDaysDeleteModal] = useState(false);
  const [exception_id, setException_id] = useState(false);
  const [switchLimit, setSwitchLimit] = useState(false);
  const [numbersList, setNumbersList] = useState(() => {
    const list = [];
    for (let i = 0; i <= 100; i++) {
      list.push(i);
    }
    return list;
  });
  useEffect(() => {
    const placeOfTables = zones.map(zone => zone.place_of_table);
    setZone_list(placeOfTables);
    setSelectedZones(placeOfTables);
    const joinedString = placeOfTables.join(",");
    setFormData({
      ...formData,
      ["list_of_zones"]: String(joinedString)
    });
  }, [zones]);
  const [formData, setFormData] = useState({
    restaurant: parseInt(restaurant_id),
    closed_days_start: formatDate(new Date()),
    closed_days_end: formatDate(new Date()),
    start_time: "12:00",
    end_time: "18:00",
    list_of_zones: "",
    accept_people_per_each_time: "0"
  });
  useEffect(() => {
    setFormData({
      ...formData,
      ["accept_people_per_each_time"]: String(0)
    });
  }, [numberOfAcceptance]);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const handleChange = (e, item_name) => {
    setFormData({
      ...formData,
      [item_name]: e
    });
  };
  const handleNumberOfAcceptance = value => {
    setFormData({
      ...formData,
      ["accept_people_per_each_time"]: String(value)
    });
  };
  const handleSubmit = async e => {
    e.preventDefault();
    dispatch(createOpenClosedExceptions(restaurant_id, formData));
    setShowModal(false);
  };
  const [dateRange, setDateRange] = useState([{
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
  }]);
  const handleDateRangeChange = ranges => {
    setDateRange([{
      ...ranges.selection,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    }]);
    setFormData({
      ...formData,
      closed_days_start: ranges.selection.startDate ? formatDate(ranges.selection.startDate) : "",
      closed_days_end: ranges.selection.endDate ? formatDate(ranges.selection.endDate) : ""
    });
  };
  const handleSelectZones = newSelectedItems => {
    const joinedString = newSelectedItems.join(",");
    setFormData({
      ...formData,
      ["list_of_zones"]: joinedString
    });
    setSelectedZones(newSelectedItems);
  };
  const handleExceptionElimination = async value => {
    try {
      const response = await api.delete(`/restaurants/${restaurant_id}/OpenClosedExceptions/${value}/`);
    } catch (error) {
      console.error(error);
    }
    setShowExceptionDaysDeleteModal(false);
    dispatch(fetchOpenClosedExceptions(restaurant_id));
  };
  const handleModalClose = () => {
    setShowExceptionDaysDeleteModal(false);
  };
  const handleModalOpen = value => {
    setShowExceptionDaysDeleteModal(true);
    setException_id(value);
  };
  return <ContainerBox>
      <Header>
        <Title>{t("ui.components.openClosedExceptions.turnosExcecionais")}</Title>
        <OrangeButton onClick={handleShow}>{t("ui.components.openClosedExceptions.novoTurnoExcecional")}<FontAwesomeIcon icon={faPlus} />
        </OrangeButton>
      </Header>
      {Array.isArray(exceptions) ? <Body>
          {exceptions.filter(exception => Number(exception.accept_people_per_each_time) === 0) // Filter out exceptions with 0
      .map(exception => <HorizontalItemBox key={exception.id}>
                <div>{t("ui.components.openClosedExceptions.turnoExcecional")}</div>
                <div>{t("ui.components.openClosedExceptions.horarioReduzidoHorarioExtendidoRestauranteFechado")}</div>
                <Row>
                  <Col xs={6} md={3}>
                    {exception.closed_days_start}
                    {exception.closed_days_start !== exception.closed_days_end && <> / {exception.closed_days_end}</>}
                  </Col>
                  <Col sm={0} md={4}>
                    {exception.list_of_zones.replace(/,/g, ", ")}
                  </Col>
                  <Col sm={0} md={2}>
                    {exception.accept_people_per_each_time}
                  </Col>
                  <Col sm={0} md={2}>
                    {exception.start_time} - {exception.end_time}
                  </Col>
                </Row>
                <ActionButton onClick={() => handleModalOpen(exception.id)}>
                  <XSvgIcon width={20} height={20} strokeColor={"#99B0AD"} style={{
            marginLeft: "4px",
            marginRight: "4px"
          }} />
                </ActionButton>
              </HorizontalItemBox>)}
        </Body> : <Loader />}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ui.components.openClosedExceptions.novoTurnoExcecional2")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <FormGroup controlId="dateRange">
              <Form.Label>{t("ui.components.openClosedExceptions.dataDeInicioEDeFim")}</Form.Label>
              <StyledDateRangePicker ranges={dateRange} onChange={handleDateRangeChange} minDate={new Date()} showDateDisplay={false} months={1} direction="horizontal" locale={dateLocale} />
            </FormGroup>

            <FormGroup controlId="startTime">
              <Form.Label>{t("ui.components.openClosedExceptions.horaDeInicio")}</Form.Label>
              <DropDownButtonTime options={generateIntervalOptions()} handleOptionChange={e => handleChange(e, "start_time")} initialOption={"12:00"} />
            </FormGroup>
            <FormGroup controlId="endTime">
              <Form.Label>{t("ui.components.openClosedExceptions.horaDeFim")}</Form.Label>
              <DropDownButtonTime options={generateIntervalOptions()} handleOptionChange={e => handleChange(e, "end_time")} initialOption={"18:00"} />
            </FormGroup>
            <FormGroup controlId="zones">
              <Form.Label>{t("ui.components.openClosedExceptions.salas")}</Form.Label>
              <CustomSelectArray items={zone_list} onSelectChange={handleSelectZones} selectedItems={selectedZones} />
            </FormGroup>

            <div className="text-right">
              <OrangeButton variant="danger" onClick={handleClose}>{t("ui.components.openClosedExceptions.cancelar")}</OrangeButton>
              <SubmitButton type="submit">{t("ui.components.openClosedExceptions.gravar")}</SubmitButton>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showExceptionDaysDeleteModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ui.components.openClosedExceptions.eliminarExcecao")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("ui.components.openClosedExceptions.temACertezaDeQueDeseja")}</Modal.Body>
        <Modal.Footer>
          <OrangeButton onClick={handleModalClose} variant="secondary">{t("ui.components.openClosedExceptions.cancelar2")}</OrangeButton>
          <OrangeButton onClick={() => handleExceptionElimination(exception_id)} variant="danger">{t("ui.components.openClosedExceptions.eliminar")}</OrangeButton>
        </Modal.Footer>
      </Modal>
    </ContainerBox>;
};
function formatDate(date) {
  const d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  return [year, month.padStart(2, "0"), day.padStart(2, "0")].join("-");
}
export default OpenClosedExceptions;
